<div class="swiper-container" *ngIf="loaded">
  <swiper [config]="carouselConfig">
    <ng-template swiperSlide *ngFor="let img of images">
      <div class="container-img">
        <img [src]="img" alt="">
      </div>
      <!-- <section class="parallax-bg" [style.background-image]="'url('+img+')'">
      </section>
      <section class="parallax-content">
        <div>
          <h1>Parallax section</h1>
          <p>Este texto acompaña al background parallax en su propia sección</p>
        </div>
      </section> -->
    </ng-template>

    <!-- VIDEOS -->
    <!-- <ng-template swiperSlide *ngFor="let video of videos">
      <div class="container-video">
        <iframe class="responsive-iframe" [src]="video" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>
      </div>
    </ng-template> -->
  </swiper>

</div>
